// components/Header/UserMenu.jsx
import React from 'react';
import { Menu, MenuItem, Divider } from '@mui/material';
import { User, Package, Settings, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { UserInfo } from './UserInfo';

export const UserMenu = ({ anchorEl, open, onClose }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { isDark } = useTheme();
  const navigate = useNavigate();

  const handleNavigate = (path, state = {}) => {
    onClose();
    navigate(path, { state });
  };

  const handleLogout = async () => {
    onClose();
    try {
      await logout();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const menuItems = [
    {
      label: t('myProfile') || 'Profile & Settings',
      icon: User,
      onClick: () => handleNavigate('/user/profile'),
    },
    {
      label: t('myOrders') || 'My Orders',
      icon: Package,
      onClick: () => handleNavigate('/user/orders'),
    },
    {
      label: t('settings.title') || 'Settings',
      icon: Settings,
      onClick: () => handleNavigate('/settings'),
    },
  ];

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: isDark
            ? '0 4px 20px rgba(0, 0, 0, 0.4)'
            : '0 4px 20px rgba(0, 0, 0, 0.1)',
          mt: 1,
          bgcolor: 'background.paper',
          minWidth: 200,
        },
      }}
    >
      <UserInfo />
      <Divider />

      {menuItems.map((item) => {
        const Icon = item.icon;
        return (
          <MenuItem
            key={item.label}
            onClick={item.onClick}
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              py: 1.25,
              '&:hover': {
                bgcolor: isDark ? 'action.hover' : 'primary.light',
                color: isDark ? 'text.primary' : 'primary.dark',
              },
            }}
          >
            <Icon size={18} style={{ marginRight: 8 }} />
            {item.label}
          </MenuItem>
        );
      })}

      <Divider />

      <MenuItem
        onClick={handleLogout}
        sx={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          py: 1.25,
          color: 'error.main',
          '&:hover': {
            bgcolor: 'error.light',
          },
        }}
      >
        <LogOut size={18} style={{ marginRight: 8 }} />
        {t('logout') || 'Logout'}
      </MenuItem>
    </Menu>
  );
};